/** What's New (M57): release notes as a list, used in Settings and in the one-time panel after an update. */
import { useState } from 'react';
import { RELEASE_NOTES, markNotesSeen, notesToShow, type ReleaseNotes } from '../lib/whats-new.ts';
import { useI18n } from '../lib/i18n.tsx';
import { Button, Drawer } from '../ui/ui.tsx';

export function WhatsNewList({ notes = RELEASE_NOTES }: { notes?: ReleaseNotes[] }) {
  const i18n = useI18n();
  const { t } = i18n;
  return (
    <section className="whats-new" aria-labelledby="whats-new-title">
      <h2 id="whats-new-title">{t('news.title')}</h2>
      {notes.map(n => (
        <article key={n.id} className="whats-new-release">
          <h3>{i18n.date.format(new Date(n.date + 'T12:00:00Z'))}</h3>
          <ul>{n.items.map(k => <li key={k}>{t(k)}</li>)}</ul>
        </article>
      ))}
    </section>
  );
}

/** Shown once after an update that brought new notes; closing it (or Got it) remembers that. */
export function WhatsNewAfterUpdate() {
  const { t } = useI18n();
  const [notes, setNotes] = useState<ReleaseNotes[]>(() => notesToShow(typeof localStorage === 'undefined' ? null : localStorage));
  if (!notes.length) return null;
  const close = () => { markNotesSeen(typeof localStorage === 'undefined' ? null : localStorage); setNotes([]); };
  return <Drawer title={t('news.title')} onClose={close} footer={<Button variant="primary" onClick={close}>{t('news.gotIt')}</Button>}>
    <WhatsNewList notes={notes} />
  </Drawer>;
}
